<template>
  <div class="wing-layout">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs :crm_id="this.$route.params.id"/>
            <div class="krprocess-wrap">
              <div class="basic-title"><em>基本信息</em></div>
              <div class="krprocess-header-wrap">
                <el-row>
                  <el-col :span="6">
                    <label>姓名：</label>
                    <span>{{ baseInfo.custom_name ? baseInfo.custom_name : '无' }}</span>
                  </el-col>
                  <el-col :span="6">
                    <label>户籍所在：</label>
                    <span>{{ baseInfo.custom_place_area ? baseInfo.custom_place_area : '无' }}</span>
                  </el-col>
                  <el-col :span="6">
                    <label>学历：</label>
                    <span>{{ baseInfo.custom_education ? baseInfo.custom_education : '无' }}</span>
                  </el-col>
                  <el-col :span="6">
                    <label>初始入学时间：</label>
                    <span>{{ baseInfo.custom_year }}</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">
                    <label>咨询老师：</label>
                    <span>{{ baseInfo.crm_sayer_str ? baseInfo.crm_sayer_str : '无' }}</span>
                  </el-col>
                  <el-col :span="6">
                    <label>文案老师：</label>
                    <span>{{ baseInfo.crm_writer_str ? baseInfo.crm_writer_str : '无' }}</span>
                  </el-col>
                  <el-col :span="6">
                    <label>项目状态：</label>
                    <jm-dict-select
                      clearable
                      v-model="baseInfo.write_info.apply_status"
                      type="jiemo"
                      class="jm-input220"
                      :show="true"
                      dict-type="korea_apply_status"/>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">
                    <el-button
                      v-if="isSave"
                      type="success"
                      size="medium"
                      @click="resetClick">再次办理文案</el-button>
                  </el-col>
                </el-row>
              </div>
              <div class="krprocess-header-wrap">
                <el-row>
                  <el-col :span="6">
                    <label>项目类型：</label>
                    <jm-dict-select
                      clearable
                      v-model="baseInfo.write_info.write_type"
                      type="jiemo"
                      class="jm-input220"
                      dict-type="korea_school_type"/>
                  </el-col>
                  <el-col :span="6" v-show="haveLanguage">
                    <label>语学院入学时间：</label>
                    <el-date-picker
                      v-if="isWriteLeader || isSayer"
                      v-model="baseInfo.write_info.apply_date"
                      type="month"
                      class="jm-input220"
                      format="yyyy-MM"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择"/>
                    <span v-if="!isWriteLeader && !isSayer">{{ baseInfo.write_info.write_date }}</span>
                  </el-col>
                  <el-col :span="6" v-show="haveCollege">
                    <label>大学入学时间：</label>
                    <el-date-picker
                      v-if="isWriteLeader || isSayer"
                      v-model="baseInfo.write_info.apply_date1"
                      type="month"
                      class="jm-input220"
                      format="yyyy-MM"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择"/>
                    <span v-if="!isWriteLeader && !isSayer">{{ baseInfo.write_info.write_date1 }}</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6" v-if="haveLanguage">
                    <el-checkbox :true-label="1" :false-label="0" v-model="baseInfo.write_info.free_language">免费语学院</el-checkbox>
                  </el-col>
                  <el-col :span="6">
                    <el-checkbox :true-label="1" :false-label="0" v-model="baseInfo.write_info.submit_writer">递交文案</el-checkbox>
                  </el-col>
                </el-row>
                <el-row v-if="isWriterSave">
                  <el-col :span="6">
                    <label>签证：</label>
                    <jm-dict-select
                      clearable
                      v-model="baseInfo.write_info.visa"
                      type="jiemo"
                      class="jm-input220"
                      dict-type="korea_visa"/>
                  </el-col>
                  <el-col :span="6">
                    <label>赴韩：</label>
                    <jm-dict-select
                      clearable
                      v-model="baseInfo.write_info.go"
                      type="jiemo"
                      class="jm-input220"
                      dict-type="korea_go"/>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <label>备注：</label>
                    <el-input
                      type="textarea"
                      :rows="2"
                      placeholder="请输入内容"
                      v-model="baseInfo.write_info.remark"/>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-button
                      v-if="isSave"
                      type="primary"
                      size="medium"
                      @click="baseInfoSave">保存基本信息</el-button>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="krprocess-wrap" v-show="haveLanguage">
              <div class="basic-title">
                <em>语学院</em>
                <el-popover placement="top-start" trigger="click" v-if="isSave">
                  <label>学校名称：</label>
                  <jm-school-search
                    :country-id="672"
                    v-model="addSchoolName"/>
                  <el-button
                    class="marginleft10"
                    type="primary"
                    @click="saveAddSchool(0)">确定</el-button>
                  <el-button
                    type="primary"
                    slot="reference"
                    size="small">添加学校</el-button>
                </el-popover>
              </div>
              <el-collapse
                class="krprocess-margin"
                v-model="languageSchoolKey"
                accordion>
                <el-collapse-item
                  :class="item.is_del === 1 ? 'collapse-del-style' : ''"
                  v-for="item in languageSchoolList"
                  :key="item.id"
                  :name="`p_${item.id}`">
                  <template slot="title">
                    <span>【 {{ item.sh_name }} 】</span>
                    <span class="apply-date-text">{{ item.apply_date_str }}</span>
                    <span :class="`apply-datestatus-text ${item.apply_date_status !== 1 ? 'red' : 'green'}`" v-if="item.apply_date_str !== '未设置入学时间' && item.apply_date_status !== 0">
                      {{ item.apply_date_status === 1 ? '提前' : '延期' }}
                    </span>
                    <jm-dict-select
                      clearable
                      v-model="item.apply_status"
                      type="jiemo"
                      text-class="apply-status-text"
                      :show="true"
                      dict-type="korea_apply_info_status"/>
                    <div v-show="item.is_del === 0 && isWriterSave">
                      <el-button
                        v-show="item.apply_status === 0"
                        type="success"
                        @click.stop="headerClick(item, 10)"
                        size="small">入学</el-button>
                      <el-button
                        v-show="item.apply_status === 0"
                        type="info"
                        @click.stop="headerClick(item, 1)"
                        size="small">退办</el-button>
                      <el-button
                        v-show="item.apply_status === 0"
                        type="warning"
                        @click.stop="headerClick(item, 2)"
                        size="small">暂停</el-button>
                      <el-button
                        v-show="item.apply_status === 2"
                        type="success"
                        @click.stop="headerClick(item, 0)"
                        size="small">激活</el-button>
                    </div>
                    <div class="btn-right-wrap" @click.stop>
                      <el-button
                        v-show="item.apply_status !== 10 && item.is_del === 0 && (isWriterSave || isSayer)"
                        type="danger"
                        @click.stop="headerClick(item, 'isdel')"
                        size="small">失效</el-button>
                      <el-button
                        v-show="item.apply_status !== 10 && item.is_del === 1 && (isWriterSave || isSayer)"
                        type="success"
                        @click.stop="headerClick(item, 'notdel')"
                        size="small">开启</el-button>
                      <el-popover placement="top-start" trigger="click" v-if="isWriterSave">
                        <label>入学时间：</label>
                        <el-date-picker
                          v-model="item.apply_date"
                          type="month"
                          class="jm-input220"
                          format="yyyy-MM"
                          value-format="yyyy-MM-dd"
                          placeholder="请选择"/>
                        <el-button
                          class="marginleft10"
                          type="primary"
                          @click="saveSchoolTime(item)">确定</el-button>
                        <el-button
                          v-show="item.apply_status === 0 && item.is_del === 0"
                          type="primary"
                          slot="reference"
                          size="small">修改入学时间</el-button>
                      </el-popover>
                    </div>
                  </template>
                  <div class="krprocess-list-wrap">
                    <el-row>
                      <el-col :span="6">
                        <label>申请材料：</label>
                        <jm-dict-select
                          v-model="item.apply_data"
                          placeholder="请选择"
                          class="jm-input220"
                          type="jiemo"
                          dict-type="korea_apply_data"
                        />
                      </el-col>
                      <el-col :span="6">
                        <label>学费：</label>
                        <jm-dict-select
                          v-model="item.apply_cost"
                          class="jm-input220"
                          placeholder="请选择"
                          type="jiemo"
                          dict-type="korea_apply_cost"
                        />
                      </el-col>
                      <el-col :span="6">
                        <label>宿舍：</label>
                        <jm-dict-select
                          v-model="item.hostel"
                          class="jm-input220"
                          placeholder="请选择"
                          type="jiemo"
                          dict-type="korea_hostel"
                        />
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="6">
                        <label>标入：</label>
                        <jm-dict-select
                          v-model="item.apply_permit"
                          class="jm-input220"
                          placeholder="请选择"
                          type="jiemo"
                          dict-type="korea_apply_permit"
                        />
                      </el-col>
                      <el-col :span="6">
                        <label>申请结果：</label>
                        <jm-dict-select
                          v-model="item.apply_result"
                          class="jm-input220"
                          placeholder="请选择"
                          type="jiemo"
                          :empty-value="'0'"
                          dict-type="korea_apply_result"
                        />
                      </el-col>
                      <el-col :span="6">
                        <label>申请结果时间：</label>
                        <span>{{ item.apply_result_time ? item.apply_result_time : '无' }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="18">
                        <label>备注：</label>
                        <el-input
                          type="textarea"
                          :rows="2"
                          placeholder="请输入内容"
                          v-model="item.remark"/>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <label/>
                        <el-button
                          type="primary"
                          size="medium"
                          @click="schoolEditSave(item)">确定</el-button>
                      </el-col>
                    </el-row>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
            <div class="krprocess-wrap" v-show="haveCollege">
              <div class="basic-title">
                <em>大学</em>
                <el-popover placement="top-start" trigger="click" v-if="isSave">
                  <label>学校名称：</label>
                  <jm-school-search
                    :country-id="672"
                    v-model="addSchoolName2"/>
                  <label>&ensp;专业名称：</label>
                  <el-input
                    type="text"
                    class="jm-input175"
                    placeholder="请输入专业"
                    v-model="pfName"/>
                  <el-button
                    class="marginleft10"
                    type="primary"
                    @click="saveAddSchool(1)">确定</el-button>
                  <el-button
                    type="primary"
                    slot="reference"
                    size="small">添加学校</el-button>
                </el-popover>
              </div>
              <el-collapse
                class="krprocess-margin"
                v-model="universitySchoolKey"
                accordion>
                <el-collapse-item
                  :class="item.is_del === 1 ? 'collapse-del-style' : ''"
                  v-for="item in universitySchoolList"
                  :key="item.id"
                  :name="`p_${item.id}`">
                  <template slot="title">
                    <span>【 {{ item.sh_name }} 】{{ item.pf_name === null || item.pf_name === '' ? '' : '-' + item.pf_name }}</span>
                    <span class="apply-date-text">{{ item.apply_date_str }}</span>
                    <span :class="`apply-datestatus-text ${item.apply_date_status !== 1 ? 'red' : 'green'}`" v-if="item.apply_date_str !== '未设置入学时间' && item.apply_date_status !== 0">
                      {{ item.apply_date_status === 1 ? '提前' : '延期' }}
                    </span>
                    <jm-dict-select
                      clearable
                      v-model="item.apply_status"
                      type="jiemo"
                      text-class="apply-status-text"
                      :show="true"
                      dict-type="korea_apply_info_status"/>
                    <div v-show="item.is_del === 0 && isWriterSave">
                      <el-button
                        v-show="item.apply_status === 0"
                        type="success"
                        @click.stop="headerClick(item, 10)"
                        size="small">入学</el-button>
                      <el-button
                        v-show="item.apply_status === 0"
                        type="info"
                        @click.stop="headerClick(item, 1)"
                        size="small">退办</el-button>
                      <el-button
                        v-show="item.apply_status === 0"
                        type="warning"
                        @click.stop="headerClick(item, 2)"
                        size="small">暂停</el-button>
                      <el-button
                        v-show="item.apply_status === 2"
                        type="success"
                        @click.stop="headerClick(item, 0)"
                        size="small">激活</el-button>
                    </div>
                    <div class="btn-right-wrap" @click.stop>
                      <el-button
                        v-show="item.apply_status !== 10 && item.is_del === 0 && (isWriterSave || isSayer)"
                        type="danger"
                        @click.stop="headerClick(item, 'isdel')"
                        size="small">失效</el-button>
                      <el-button
                        v-show="item.apply_status !== 10 && item.is_del === 1 && (isWriterSave || isSayer)"
                        type="success"
                        @click.stop="headerClick(item, 'notdel')"
                        size="small">开启</el-button>
                      <el-popover placement="top-start" trigger="click" v-if="isWriterSave">
                        <label>入学时间：</label>
                        <el-date-picker
                          v-model="item.apply_date"
                          type="month"
                          class="jm-input220"
                          format="yyyy-MM"
                          value-format="yyyy-MM-dd"
                          placeholder="请选择"/>
                        <el-button
                          v-if="isWriterSave"
                          class="marginleft10"
                          type="primary"
                          @click="saveSchoolTime(item)">确定</el-button>
                        <el-button
                          v-show="item.apply_status === 0 && item.is_del === 0"
                          type="primary"
                          slot="reference"
                          size="small">修改入学时间</el-button>
                      </el-popover>
                    </div>
                  </template>
                  <div class="krprocess-list-wrap">
                    <el-row>
                      <el-col :span="12">
                        <div @click="changeUniversityTempo(item, 0)" :class="item.apply_step >= 0 ? 'process-university-title active' : 'process-university-title'">
                          <i>1</i>
                          <span>申请材料</span>
                        </div>
                        <div @click="changeUniversityTempo(item, 1)" :class="item.apply_step >= 1 ? 'process-university-title active' : 'process-university-title'">
                          <i>2</i>
                          <span>面试</span>
                        </div>
                        <div @click="changeUniversityTempo(item, 2)" :class="item.apply_step >= 2 ? 'process-university-title active' : 'process-university-title'">
                          <i>3</i>
                          <span>申请结果</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row v-show="item.apply_step_view === 0">
                      <el-row>
                        <el-col :span="6">
                          <label>*申请材料：</label>
                          <jm-dict-select
                            v-model="item.apply_data"
                            placeholder="请选择"
                            class="jm-input220"
                            type="jiemo"
                            dict-type="korea_apply_data"
                          />
                        </el-col>
                        <el-col :span="6">
                          <label>递交时间：</label>
                          <span>{{ item.apply_data_time ? item.apply_data_time : '无' }}</span>
                        </el-col>
                      </el-row>
                    </el-row>
                    <el-row v-show="item.apply_step_view === 1">
                      <el-row>
                        <el-col :span="6">
                          <label>*面试：</label>
                          <jm-dict-select
                            v-model="item.interview"
                            placeholder="请选择"
                            class="jm-input220"
                            type="jiemo"
                            dict-type="korea_interview"
                          />
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="6">
                          <label>面试时间：</label>
                          <el-date-picker
                            v-model="baseInfo.write_info.interview_date"
                            type="date"
                            class="jm-input220"
                            format="yyyy-MM-DD"
                            placeholder="请选择"/>
                        </el-col>
                      </el-row>
                    </el-row>
                    <el-row v-show="item.apply_step_view === 2">
                      <el-row>
                        <el-col :span="6">
                          <label>*申请结果：</label>
                          <jm-dict-select
                            v-model="item.apply_result"
                            placeholder="请选择"
                            class="jm-input220"
                            type="jiemo"
                            dict-type="korea_apply_result"
                          />
                        </el-col>
                        <el-col :span="6">
                          <label>申请结果时间：</label>
                          <span>{{ item.apply_result_time ? item.apply_result_time : '无' }}</span>
                        </el-col>
                      </el-row>
                      <el-row v-show="item.apply_result === '3'">
                        <el-col :span="6">
                          <label>上传offer：</label>
                          <jm-upload
                            class="upload-img"
                            action="/newfib.php/index/Offer_small/upload"
                            :show-file-list="true"
                            :data="{}"
                          >
                            <el-button
                              type="primary">上传图片</el-button>
                          </jm-upload>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="6">
                          <label>是否接受offer：</label>
                          <jm-dict-select
                            v-model="item.offer"
                            placeholder="请选择"
                            class="jm-input220"
                            type="jiemo"
                            dict-type="korea_offer"
                          />
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="6">
                          <label>奖学金：</label>
                          <jm-dict-select
                            v-model="item.scholarship"
                            placeholder="请选择"
                            class="jm-input220"
                            type="jiemo"
                            dict-type="korea_scholarship"
                          />
                        </el-col>
                        <el-col :span="6" v-show="item.scholarship === '1'">
                          <label>奖学金金额：</label>
                          <el-input
                            type="text"
                            class="jm-input220"
                            placeholder="请输入金额"
                            v-model="item.scholarship_num"/>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="6">
                          <label>学费：</label>
                          <jm-dict-select
                            v-model="item.apply_cost"
                            placeholder="请选择"
                            class="jm-input220"
                            type="jiemo"
                            dict-type="korea_apply_cost"
                          />
                        </el-col>
                        <el-col :span="6">
                          <label>宿舍：</label>
                          <jm-dict-select
                            v-model="item.hostel"
                            placeholder="请选择"
                            class="jm-input220"
                            type="jiemo"
                            dict-type="korea_hostel"
                          />
                        </el-col>
                        <el-col :span="6">
                          <label>标入：</label>
                          <jm-dict-select
                            v-model="item.apply_permit"
                            placeholder="请选择"
                            class="jm-input220"
                            type="jiemo"
                            dict-type="korea_apply_permit"
                          />
                        </el-col>
                      </el-row>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <label/>
                        <el-button
                          v-if="isWriterSave"
                          type="primary"
                          size="medium"
                          @click="schoolEditSave(item)">确定</el-button>
                      </el-col>
                    </el-row>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { messageBox } from '@/utils/messagebox';
import { Loading } from 'element-ui';
import { crumbs, jmSchoolSearch, jmAreaselect, jmEducationSelect, jmDictSelect } from '@/components/tool/index.js';

export default {
  data() {
    return {
      domicile: [],
      education: [],
      crmId: null,
      baseInfo: {
        write_info: {
          apply_status: 0,
          free_language: 0,
          submit_writer: 0
        }
      }, // 基本信息数据
      applyId: 0, // 文案流程id
      resetLock: false, // 再次办理锁
      languageSchoolKey: '1', // 语学院列表绑定id
      universitySchoolKey: '2', // 大学列表绑定id
      languageSchoolList: [], // 语学院列表数据
      universitySchoolList: [], // 大学列表数据
      addSchoolName: '', // 语学院添加院校名称
      addSchoolName2: '', // 大学添加院校名称
      pfName: ''
    };
  },
  components: {
    'jm-crumbs': crumbs, // 面包屑
    jmSchoolSearch,
    jmAreaselect,
    jmEducationSelect,
    jmDictSelect,
  },
  beforeCreate() {

  },
  created() {
    this.crmId = this.$route.params.id;
    this.applyId = this.$route.params.applyid;
  },
  computed: {
    readonly() {
      return !this.$hasPermission([75, 76, 19, 33, 58]);
    },
    isWriteLeader() {
      // 文案主管
      return this.$hasPermission([136]);
    },
    isWriter() {
      // 文案老师
      console.log(this.$store.getters.userInfo.userid, this.baseInfo.crm_writer);
      return this.$hasPermission([135]) && this.$store.getters.userInfo.userid === this.baseInfo.crm_writer;
    },
    isSayerLeader() {
      // 文案老师
      return this.$hasPermission([22]);
    },
    isSayer() {
      // 文案老师
      return this.$hasPermission([54]) && this.$store.getters.userInfo.userid === this.baseInfo.crm_sayer;
    },
    isSave() {
      return this.isWriteLeader || this.isWriter || this.isSayer || this.isSayerLeader;
    },
    isWriterSave() {
      return this.isWriteLeader || this.isWriter;
    },
    haveCollege() {
      return Number(this.baseInfo.write_info.write_type) !== 1;
    },
    haveLanguage() {
      return [1, 6, 7, 8].indexOf(Number(this.baseInfo.write_info.write_type)) !== -1;
    }
  },
  methods: {
    /**
     * 填充用户户籍地信息
     */
    initDomicile() {
      this.domicile = [
        this.baseInfo.custom_place_area,
        this.baseInfo.custom_place_city
      ];
    },
    initEducation() {
      this.education = [
        this.baseInfo.custom_education,
        this.baseInfo.custom_detail
      ];
    },
    // 学校状态点击
    headerClick(val, mode) {
      let txt = '';
      switch (mode) {
        case 1: txt = '退办'; break;
        case 2: txt = '暂停'; break;
        case 10: txt = '入学'; break;
        case 0: txt = '申请中'; break;
        case 'isdel': txt = '失效'; break;
        default: txt = '-';
      }
      messageBox.msgBox({ message: `是否确认将该学校状态设置为${txt}？` }).then(() => {
        let isdel = val.is_del;
        let status = val.apply_status;
        if (mode === 'isdel') {
          isdel = 1;
        } else if (mode === 'notdel') {
          isdel = 0;
        } else {
          status = mode;
        }
        this.$http._post({
          url: '/index/kr_Process/changeSchoolStatus',
          data: { id: val.id, apply_status: status, is_del: isdel }
        }).then((response) => {
          if (response.result > -1) {
            this.$message.success('修改状态成功');
            this.getUserBase();
          }
        });
      }).catch(() => {
      });
    },
    // 添加学校保存
    saveAddSchool(val) {
      let shname = val === 0 ? this.addSchoolName : this.addSchoolName2;
      let applyDate = val === 0 ? this.baseInfo.write_info.apply_date : this.baseInfo.write_info.apply_date1;
      // console.log(shname);
      if (shname.sh_id && shname.value) {
        this.$http._post({
          url: '/index/kr_Process/addSchool',
          data: {
            crm_id: this.crmId,
            school_mold: val,
            apply_id: this.applyId,
            sh_name: shname.value,
            sh_id: shname.sh_id,
            apply_date: applyDate,
            pf_name: this.pfName
          }
        }).then((response) => {
          if (response.result > -1) {
            this.$message.success('保存成功');
            this.getSchool();
            this.addSchoolName = '';
            this.addSchoolName2 = '';
            this.pfName = '';
          }
        });
      }
    },
    // 学校编辑保存
    schoolEditSave(val) {
      val.apply_result = val.apply_result === 'null' ? 0 : val.apply_result;
      val.apply_data = val.apply_data === 'null' ? 0 : val.apply_data;
      this.$http._post({
        url: '/index/kr_Process/editSchool',
        data: { ...val }
      }).then((response) => {
        if (response.result > -1) {
          this.$message.success('保存成功');
          this.getSchool();
        }
      });
    },
    // 修改入学时间
    saveSchoolTime(val) {
      this.$http._post({
        url: '/index/kr_Process/editSchoolApplyDate',
        data: { ...val }
      }).then((response) => {
        if (response.result > -1) {
          this.$message.success('保存成功');
          this.getSchool();
        }
      });
    },
    // 获取语学院信息
    getLanguageSchool(applyId) {
      let loadingInstance = Loading.service();
      this.$http._post({
        url: '/index/kr_Process/showSchool',
        data: {
          apply_id: applyId,
          school_mold: 0
        }
      }).then((response) => {
        loadingInstance.close();
        this.languageSchoolList = this.initStepView(response.data);
      });
    },
    // 获取大学信息
    getUniversitySchool(applyId) {
      let loadingInstance = Loading.service();
      this.$http._post({
        url: '/index/kr_Process/showSchool',
        data: {
          apply_id: applyId,
          school_mold: 1
        }
      }).then((response) => {
        loadingInstance.close();
        this.universitySchoolList = this.initStepView(response.data);
      });
    },
    // 获取基本信息
    getUserBase() {
      let isReset = '';
      if (this.resetLock) {
        isReset = 1;
      }
      let loadingInstance = Loading.service();
      this.$http._post({
        url: '/index/kr_Process/showProcess',
        data: {
          crm_id: this.crmId,
          apply_id: this.applyId,
          refresh: isReset
        }
      }).then((response) => {
        loadingInstance.close();
        if (!response.data.write_info) {
          this.resetLock = true;
          this.getUserBase();
          return false;
        }
        this.baseInfo = response.data;
        this.initDomicile();
        this.initEducation();
        this.applyId = this.baseInfo.write_info.id;
        let replaceReg = new RegExp('-[0-9]{2}$', 'i');
        this.baseInfo.write_info.apply_date = this.baseInfo.write_info.apply_date === '0000-00-00' ? '' : this.baseInfo.write_info.apply_date;
        this.baseInfo.write_info.apply_date1 = this.baseInfo.write_info.apply_date1 === '0000-00-00' ? '' : this.baseInfo.write_info.apply_date1;
        this.baseInfo.write_info.write_date = this.baseInfo.write_info.apply_date.replace(replaceReg, '');
        this.baseInfo.write_info.write_date1 = this.baseInfo.write_info.apply_date1.replace(replaceReg, '');
        // 判断读取哪些学校接口
        this.getSchool();
      });
    },
    // 获取院校信息
    getSchool() {
      if (this.haveLanguage) {
        this.getLanguageSchool(this.baseInfo.write_info.id);
      }
      if (this.haveCollege) {
        this.getUniversitySchool(this.baseInfo.write_info.id);
      }
    },
    // 再次办理点击
    resetClick() {
      messageBox.msgBox({ message: '再次办理流程，确定后会重置所有文案流程，是否继续' }).then(() => {
        this.resetLock = true;
        this.languageSchoolList = [];
        this.universitySchoolList = [];
        this.getUserBase();
      }).catch(() => {
      });
    },
    // 保存基本信息
    baseInfoSave() {
      if (!this.haveCollege) {
        // 没有大学时，大学入学时间为空
        this.baseInfo.write_info.apply_date1 = '';
      }
      if (!this.haveLanguage) {
        // 没有语学院时，语学院入学时间为空
        this.baseInfo.write_info.apply_date = '';
      }
      this.$http._post({
        url: '/index/kr_Process/editProcess',
        data: { ...this.baseInfo.write_info }
      }).then((response) => {
        if (response.result > -1) {
          window.location.reload();
          this.$message.success('保存成功');
        }
      });
    },
    // 大学步骤点击
    changeUniversityTempo(val, mode) {
      if (val.apply_step >= mode) {
        val.apply_step_view = mode;
      }
    },
    initStepView(list) {
      list.map((value) => {
        value.apply_step_view = value.apply_step;
        value.apply_data = value.apply_data === 0 ? 'null' : value.apply_data;
        value.apply_result = value.apply_result === 0 ? 'null' : value.apply_result;
        return value;
      });
      return list;
    }
  },
  mounted() {
    this.getUserBase();
  }
};
</script>
<style scoped>
  .marginleft10{
    margin-left: 10px;
  }
  .krprocess-header-wrap{
    margin:0 8px;
    border-bottom: 1px solid #ccc;
    padding: 15px 0;
  }
  .krprocess-header-wrap .el-col{
    margin: 7.5px auto;
  }
  .krprocess-header-wrap span{
    font-size: 14px;
  }
  .krprocess-wrap{
    padding-top: 20px;
  }
  .krprocess-wrap .basic-title{
    margin-bottom: 0;
  }
  .krprocess-wrap .basic-title .el-button{
    margin-left: 15px;
  }
  .krprocess-wrap .el-textarea{
    width: 90%;
    vertical-align: top;
  }
  .krprocess-margin{
    margin: 15px 8px;
  }
  .btn-right-wrap{
    position: absolute;
    right: 70px;
    top: auto;
    bottom: auto;
  }
  .btn-right-wrap .el-button{
    margin-left: 10px;
  }
  .krprocess-list-wrap{
    padding: 15px;
  }
  .krprocess-list-wrap .el-row{
    margin-bottom: 15px;
    line-height: 36px;
  }
  .process-university-title{
    display: inline-block;
    margin: 0 40px;
    cursor: pointer;
    text-align: center;
  }
  .process-university-title i{
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 100%;
    border: 1px solid #999;
    text-align: center;
    font-size: 12px;
  }
  .process-university-title.active i{
    background: #2196f3;
    color: #fff;
    border-color: #2196f3;
  }
  .krprocess-list-wrap .el-row label{
    min-width: 70px;
    text-align: right;
    display: inline-block;
  }
  .krprocess-wrap .el-collapse-item__content{
    border: 1px solid #dfe6ec;
  }
  .krprocess-wrap .el-collapse-item:last-child{
    margin-bottom: 0;
  }
</style>
<style>
  .apply-status-text{
    margin: 0 30px;
  }
  .apply-date-text{
    margin-left: 30px;
  }
  .apply-datestatus-text{
    display: inline-block;
    vertical-align: middle;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    border-radius: 3px;
    padding:0 4px;
    margin: 0 4px;
  }
  .apply-datestatus-text.green{
    color: #67c23a;
    border: 1px solid #67c23a;
  }
  .apply-datestatus-text.red{
    color: #f56c6c;
    border: 1px solid #f56c6c;
  }
  .collapse-del-style .el-collapse-item__header{
    /*background: #888 !important;*/
    color: #f56c6c;
  }
</style>
